import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import {
  FAIL_STATUS,
  quickInsightsBaseData,
  stageBaseData,
} from "../consts";

const useAuditTrailView = () => {
  const { communityData, auditTrailDtl } = useSelector((state: RootState) => state.currentData);

  const breadcrumbData = useMemo(() => ([
    {
      link: `/${routes.cam}/${routes.activityDashboard}`,
      name: `Activity Dashboard - ${communityData?.communityName || communityData?.name || ""}`,
    },
    {
      link: `/${routes.cam}/${routes.activityDashboard}/${routes.auditTrail}`,
      name: "Audit Trail",
    },
    {
      link: "",
      name: `${[...quickInsightsBaseData, ...stageBaseData]?.find((item: any) => item.stage == auditTrailDtl?.stage)?.title || ""} Details`
    },
  ]), [auditTrailDtl]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  
  const isFailStatus = useMemo(() => auditTrailDtl?.processingStatus === FAIL_STATUS, [auditTrailDtl]);

  return {
    breadcrumbData,
    isFailStatus,
    pageTitle: breadcrumbData[breadcrumbData.length - 1]?.name || "",
    auditTrailData: auditTrailDtl
  };
};

export default useAuditTrailView;
